import React, { useMemo } from "react";
import styled from "styled-components";

import { renderColumn } from "utils";
import BaseTable from "components/base/BaseTable";
import { ServiceLink } from "components/Navigation/ServiceLink";
import { Checkbox, Tooltip } from "rsuite";
import Whisper from "components/Whisper";

// import {renderColumn} from "utils/helpers";


export default ({
    dataList = [],
    page,
    perPage,
    sort,
    count,
    loading,
    isMobile,

    deleteKeys,

    getItems,
    setDeleteKeys,

    ...props
}) => {

    const columns = useMemo(() => [
        {
            id: "prefix",
            dataKey: "prefix",
            align: "left",
            className: "prefix",
            label: "Prefix",
            width: 150
        },
        {
            id: "account_list",
            dataKey: "account_list",
            value: ({ account_list = [] }) => {
                return <DialerList dialerList={account_list} />
            },
            align: "left",
            label: "Allocted to dialers",
            className: "account_list",
            // width: 260,
            flexGrow: 2
        },
        {
            id: "comment",
            dataKey: "comment",
            value: ({ comment = "" }) => {
                return <Whisper
                    speaker={<Tooltip>{comment}</Tooltip>}
                    trigger="hover"
                    placement="auto"
                >
                    <span>{comment}</span>
                </Whisper>;
            },
            align: "left",
            className: "comment",
            label: "Comment",
            // width: 120,
            flexGrow: 1
        },
        {
            id: "select",
            label: "Select to delete",
            dataKey: "select",
            align: "center",
            width: 120,
            value: ({ prp_key: key }) => {
                return (
                    <StyledCheckbox
                        disabled={key === null}
                        checked={deleteKeys.includes(key)}
                        onChange={(_, checked) => {
                            if (!deleteKeys.includes(key) && checked) {
                                setDeleteKeys(prev => {
                                    return [...prev, key];
                                });
                            } else if (deleteKeys.includes(key) && !checked) {
                                setDeleteKeys(prev => prev.filter(k => k !== key));
                            }
                        }}
                    />
                );
            }
        }

    ], [deleteKeys, setDeleteKeys]);

    const renderedColumns = columns.map(renderColumn);

    return (
        <>
            <StyledTable
                className="tableFilters"
                shouldUpdateScroll={false}
                headerHeight={46}
                rowHeight={42}
                height={634}
                // wordWrap
                virtualized
                data={[...dataList]}
                {...{
                    loading
                }}
                getItems={getItems}
                columns={columns}
                originalColumns={columns}
                {...props}
            >
                {renderedColumns}
            </StyledTable>
        </>
    )
}

const StyledTable = styled(BaseTable)`
    && {
    
        .tableFilters__previewText {
            display: block;
            line-height: 20px;
            margin-top: 7px;
            word-break: normal;
        }
        
        .tableFilters_buttons {
            height: 20px;
            margin-top: 7px;
        }
    }
`;

const StyledCheckbox = styled(Checkbox)`
    && {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

const DialerList = ({ dialerList }) => {
    const dialersToShowList = dialerList.slice(0, 10);

    const nameList = dialerList.map(({ account_name }) => {
        return account_name;
    });
    const whisperText = nameList.join(", ");
    return <DialerTextList>
        {dialersToShowList.map(({ account_id, account_name }, idx) => {
            return <DialerName>
                <ServiceLink className="ranges_numbers_table_link" to={`/accounts/view/${account_id}`} target="_blank" rel="noopener noreferrer">
                    {account_name}
                </ServiceLink>
                {idx !== dialersToShowList.length - 1 ? "," : ""}
            </DialerName>
        })}
    </DialerTextList>
};

const DialerTextList = styled.span`
    && {
        font-size: 12px;
    }
`;

const DialerName = styled.span`
    && {
        margin-right: 5px;
        
        a {
            /* color: #0000EE !important; */
        }
    }
`;
